module.exports = __webpack_public_path__ + "img/slim.c3e3b8e2.png";